module.exports = __webpack_public_path__ + "img/selected7-min.5494e01d.png";